import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "list-wrapper"
}
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "rate-type" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.rateList.length)
    ? (_openBlock(), _createElementBlock("ul", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rateList, (rate, index) => {
          return (_openBlock(), _createElementBlock("li", {
            class: _normalizeClass(["list-item", { selected: _ctx.selectedRateIndex === index }]),
            key: index,
            onClick: ($event: any) => (_ctx.setSelectedRate(index))
          }, [
            _createElementVNode("p", _hoisted_3, _toDisplayString(rate.name), 1),
            _createElementVNode("p", null, _toDisplayString(rate.hasMultipleRates ? _ctx.$t('rateFinder.fromAmount', { amount: rate.amount }) : rate.amount), 1)
          ], 10, _hoisted_2))
        }), 128))
      ]))
    : _createCommentVNode("", true)
}